
const ScrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'instant'
    });
    return null
}

export default ScrollToTop